import React, { Component } from 'react';
import Sticky from 'Components/Sticky';
import ActionLoader from 'Components/ActionLoader';
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { ReactComponent as Background } from "Icons/background.svg";
import {
    RFQInformation,
    CargoInformation,
    BiddingDetails,
    GroupingProviders
} from 'Components/EXIMRFQ/CreateRFQ';
import {
    TripTableHeader,
    TripTable
} from 'Components/EXIMRFQ/Trips';
import AddTrip from 'Components/EXIMRFQ/AddTrip/index';
import RFQStatusBar from 'Components/EXIMRFQ/RFQStatusbar/index';
import BottomSticky from "Components/EXIMRFQ/BottomSticky/index";
import {
    GET_VEHICLE_TYPES,
    GET_PRICING_BASIS,
    GET_PACKING_TYPES,
    GET_PAYMENT_CYCLES,
    GET_PRODUCT_CATEGORIES,
    GET_GROUPS_AND_TRANSPORTERS,
    GET_RFQ_DETAIL,
    GET_CONTRACT_TENURE_LIST,
    UPLOAD_DOCUMENT,
    DISCARD_RFQ,
    DOWNLOAD_TRIPS_TEMPLATE,
    UPLOAD_TRIPS,
    GET_TRIPS,
    CREATE_RFQ,
    GET_VEHICLE_BODY_TYPES,
    GET_BUSINESS_VOLUMES,
    ADD_TRIP_ADDING,
    ADD_TRIP,
    DELETE_TRIP,
    GET_COST_HEADS_LIST,
    GET_CURRENCY_DETAILS,
    GET_CURRENCY_TYPES,
    GET_PORT_DETAILS
} from 'Constants/actionConstants';
import { getUser , getToken, setCookie } from 'Utils/storage';
import { downloadUrl } from 'Utils/index';
import { scroll } from 'Utils/';
import ConfirmationPopup from 'Components/ConfirmationPopup';
import Cx from 'classnames';
class EXIMRFQCreate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeView: 1,
            addTrip: false,
            rfq: props.rfq,
        }
        this.viewMode = props.match.path === '/exim/rfq/view/:id/:serviceType/:type';
    }

    componentWillReceiveProps(nextProps, props) {
        this.setState({
           isSuccessfull: false
        });
        if((nextProps.selectedNavBranch || {}).branch_id && ((nextProps.selectedNavBranch || {}).branch_id !== (this.props.selectedNavBranch || {}).branch_id)) {
           this.getConstansValues((nextProps.selectedNavBranch || {}).branch_id);
        }
     } 

     getConstansValues = (branchId = '') => {
        const { match, dispatch } = this.props;
        const user = getUser();
        const params = {
           rfqType: match.params.type && Number(match.params.type ),
           companyId: user.companyId,
           branchId: branchId ? branchId : user.branchId
        }
        dispatch({ type: GET_VEHICLE_TYPES, params });
        dispatch({
           type: GET_PRICING_BASIS,
           data: params
        });
        dispatch({
           type: GET_PACKING_TYPES,
           data: params
        });
        dispatch({
           type: GET_PAYMENT_CYCLES,
           data: params
        });
        dispatch({
           type: GET_PRODUCT_CATEGORIES,
           data: params
        })
     }

     componentDidMount() {
        const token = getToken();
        if (window.name && window.name.length > 0 && (!token || (JSON.parse(window.name))['teg-session-token'] !== token) && !(JSON.parse(window.name))['sso-logout-duration']) {
           Object.entries(JSON.parse(window.name)).forEach(([key, value]) => {
               setCookie(key, value, 200);
           });
           location.reload();
       }
        const { dispatch, match, rfq } = this.props;
        const user = getUser();
        const branchLocalName = localStorage.getItem('branchDetail');
        const name = (branchLocalName && branchLocalName.length > 0) ? JSON.parse(localStorage.getItem('branchDetail')) : '';
        // this.getBranches();
        dispatch({
            type: GET_GROUPS_AND_TRANSPORTERS,
            params: {
                branchId: name.branch_id,
                type: match.params.type == 12 ? 2 : (match.params.type == 15 ? 27 : match.params.type),
                rfqType: [12].includes(match.params.type) ? match.params.type : undefined,
                isExim: true
             }
        });
        dispatch({
            type: GET_RFQ_DETAIL,
            params: {
                rfqId: match.params.id,
                rfqType: match.params.type
            }
        });
        dispatch({ type: GET_CONTRACT_TENURE_LIST });
        dispatch({ type: GET_CURRENCY_DETAILS });
        dispatch({ type: GET_CURRENCY_TYPES });
        this.getConstansValues();
        this.getCostheads();
        if (this.viewMode) {
            dispatch({
                type: GET_TRIPS,
                params: {
                    rfqId: match.params.id,
                    rfqType: match.params.type,
                    limit: 1000,
                    offset: 0
                }
            })
        }
    }

    getCostheads = (type = 1) => {
        this.props.dispatch({
           type: GET_COST_HEADS_LIST,
           data: {
              type
           }
        })
     }

    setNextView = () => {
        const { activeView } = this.state;
        const { dispatch, trips, rfq, allSubPlants, courierZones } = this.props;
        const branchLocalName = JSON.parse(localStorage.getItem('branchDetail'));
        const rfqData = rfq.getApiData();
        const isTransporterDocumentsMandatory = true;
        if ((activeView === 1 && !rfq.cargoInfo.packingType || !(rfq.cargoInfo.cargoDetails || []).length || !rfq.rfqDetails.contractTenureTo || (isTransporterDocumentsMandatory && !rfq.isAllTransporters && !rfq.groups.length && !rfq.transporters.length) || (!rfq.documents.length) || (!rfq.biddingDetails.pricingBasis) || !rfq.biddingDetails.to || !(rfq.biddingDetails.to > rfq.biddingDetails.from))) {
            if (!rfq.rfqDetails.contractTenureTo) {
                scroll(this.rfqDetailsRef.offsetTop + 100);
            } else if ((!rfq.cargoInfo.packingType) || !(rfq.cargoInfo.cargoDetails || []).length) {
                scroll(this.cargoDetailsRef.offsetTop + 100)
            } else if ((!rfq.biddingDetails.pricingBasis) || !rfq.biddingDetails.to || !(rfq.biddingDetails.to > rfq.biddingDetails.from) || !rfq.documents.length) {
                scroll(this.biddingDetailsRef.offsetTop + 100)
            } else if (!rfq.isAllTransporters && !rfq.groups.length && !rfq.transporters.length) {
                scroll(this.transporterDetailsRef.offsetTop + 100)
            } 
            this.setState({
                cargoDetailsSubmitted: true,
                rfqDetailsSubmitted: true,
                transporterDetailsSubmitted: true,
                biddingDetailsSubmitted: true
            });
            return;
        } else if((activeView === 1 || activeView === 3) && (rfq.minimumBiddersToCreateRfq && ((((rfqData.docs_and_transporters || {}).transporters || {}).transporter_ids || []).length < rfq.minimumBiddersCountToCreateRfq))) {
            if(this.transporterDetailsRef) {
               scroll(this.transporterDetailsRef.offsetTop + 200)
               this.setState({
                  transporterDetailsSubmitted: true
               });
            } else {
               dispatch({
                  type:TOAST_ERROR,
                  duration: 3,
                  message: `Minimum Transporters To Be Selected ${rfq.minimumBiddersCountToCreateRfq}`
               });
            }
            return;
         } else if (activeView === 2 && rfq && rfq.type === 12 && (trips || []).length === 0) {
            dispatch({
               type: TOAST_ERROR,
               message: 'Please add atleast one trip'
            });
            return;
         } 
         if (activeView === 3) {
            rfq.setIsDraft(false);
         } else {
            rfq.setIsDraft(true);
         }
        if(activeView === 1) {
            dispatch({
                type: CREATE_RFQ,
                data: rfq.getApiData(),
                rfq,
                onSuccess: () => {
                   dispatch({
                      type: GET_TRIPS,
                      params: {
                         rfqId: rfq.id,
                         rfqType: rfq.type,
                         limit: 1000,
                         offset: 0
                      }
                   });
                   this.setState({
                        activeView: activeView + 1,
                        cargoDetailsSubmitted: false,
                        rfqDetailsSubmitted: false,
                        transporterDetailsSubmitted: false,
                        biddingDetailsSubmitted: false
                    });
                }
             }
          );
        }
        if(activeView === 2) {
            dispatch({
                type: CREATE_RFQ,
                data: rfq.getApiData(),
                rfq,
                onSuccess: () => {
                   dispatch({
                      type: GET_TRIPS,
                      params: {
                         rfqId: rfq.id,
                         rfqType: rfq.type,
                         limit: 1000,
                         offset: 0
                      }
                   })
                   this.setState({
                        activeView: activeView + 1
                    });
                }
             }
          );
        }
        if(activeView === 3) {
            dispatch({
                type: CREATE_RFQ,
                data: rfq.getApiData(),
                rfq,
             }
          );
        }
    }

    setPreviousView = () => {
        const { activeView } = this.state;
        this.setState({
            activeView: activeView - 1
        })
    }

   
    addTrip = (tripData, saveAndKeepAdding, isCopy) => {
        const { dispatch, trip, rfq, addingTrip } = this.props;
        const { offset, addTrip } = this.state;
        const data = {
            trip_id: (trip && !isCopy) ? trip.id : undefined,
            rfq_id: rfq.id,
            trips: rfq.type === 6 ? [...tripData] : [tripData],
            parent_trip_id: trip && trip.id ? trip.parentTripId : undefined,
        }
        // if ((trip && trip.parentTripId) || !addingTrip) {
        //    data.parent_trip_id = trip.parentTripId;
        // }
        dispatch({
            type: ADD_TRIP,
            data,
            params: {
                rfqId: rfq.id,
                rfqType: rfq.type
                // limit: 10,
                // offset
            },
            additionalParams: {
                rfqType: rfq.type
            },
            saveAndKeepAdding,
            onError: ((data) => {
                this.setState({ isTripExists: data });
            })
        });
        if(!saveAndKeepAdding) {
            this.setState({
                addTrip: !addTrip
            });
        }
        
    }

    searchGroupsAndTransporters = (search, type = 2) => {
        const { dispatch, match } = this.props;
        let branchId;
        const branchLocalName = localStorage.getItem('branchDetail');
        const name = (branchLocalName && branchLocalName.length > 0) ? JSON.parse(localStorage.getItem('branchDetail')) : '';
        dispatch({
           type: GET_GROUPS_AND_TRANSPORTERS,
           params: {
              search,
              branchId: name.branch_id,
              type: match.params.type == 12 ? type : (match.params.type == 15 ? 27 : match.params.type),
              rfqType: [12].includes(match.params.type) ? match.params.type : undefined,
              isExim: true
           }
        })
     }

    onChange = () => {
        const { rfq } = this.props;
        this.setState({
           rfq: rfq
        });
     }

    uploadDocument = (file) => {
        const { dispatch } = this.props;
        dispatch({
           type: UPLOAD_DOCUMENT,
           file,
           onSuccess: () => { this.setState({}) }
        });
    }

    removeDocument = (index) => {
        const { rfq } = this.props;
        rfq.removeDocument(index);
        this.setState({});
    }

    discardRfq = () => {
        const { dispatch, rfq } = this.props;
        if (rfq && rfq.id) {
           dispatch({
              type: DISCARD_RFQ,
              data: {
                 rfqId: rfq.id,
                 rfqType: rfq.type
              }
           })
        } else {
           localStorage.setItem('teg-component', true);
           location.href = "/seeker"
        }
     }

     downloadTrips = () => {
        const { dispatch, match, rfq } = this.props;
        dispatch({
           type: DOWNLOAD_TRIPS_TEMPLATE,
           params: {
              type: ((rfq.type == 3) ? 9 : ((getUser().showPinCodeDetails) ? 8 : (rfq.rfqDetails.serviceType === 3 ? 1 : (rfq.type==2 || rfq.type==5) ? 3 : 2))),
              rfqId: match.params.id,
              rfqType: match.params.type,
              withPincode: rfq.rfqDetails.withPincode
           },
           onSuccess: (data) => {
              downloadUrl(data.link);
           }
        });
     }
    
    uploadTrips = (file) => {
        const { dispatch, match, rfq } = this.props;
        dispatch({
            type: UPLOAD_TRIPS,
            file,
            params: {
                rfqId: match.params.id,
                type: rfq.rfqDetails.serviceType === 3 ? 1 :(rfq.type==2 || rfq.type==5) ? 3 : 2,
                rfqType: match.params.type,
                withPincode: rfq.rfqDetails.withPincode
            },
            onSuccess: (data) => {
                if (data && data.count && (data.count > 50)) {
                    setTimeout(() => {
                        this.fetchTrips({ offset: 0, limit: 1000 });
                    }, 10000);
                    this.setState({ uploadTripsCount: data.count - 1, disableSubmitTrips: true });
                } else {
                    this.fetchTrips({ offset: 0, limit: 1000 });
                }
            }
        });
    }

    fetchTrips = (filters = {}) => {
        const { dispatch, rfq } = this.props;
        dispatch({
            type: GET_TRIPS,
            params: {
                rfqId: rfq.id,
                rfqType: rfq.type,
                ...filters
            },
            onSuccess: ((data) => {
                const count = this.state.uploadTripsCount - 1;
                const tripCount = data.trips_count;
                if ((count > 0 || (count === tripCount) || tripCount === 1 ) ) {
                if (tripCount < count) {
                    this.fetchTrips();
                }
                this.setState({
                    disableSubmitTrips: (tripCount < count)
                });
                }
            })
        });
    }

    onClickAddTrip = (trip = {}) => {
        const { dispatch, rfq, selectedNavBranch } = this.props;
        const user = getUser();
        const newData = {
            rfqType: rfq.type,
            companyId: user.id,
            branchId: (selectedNavBranch || {}).branch_id || user.branchId
        }
        dispatch({ type: GET_VEHICLE_TYPES, params: newData });
        dispatch({ type: GET_VEHICLE_BODY_TYPES, params: newData });
        dispatch({ type: GET_BUSINESS_VOLUMES, data : newData });
        dispatch({
            type: ADD_TRIP_ADDING,
            trip: trip.id ? trip : null,
            addingTrip: true,
        });
        if([13, 14].includes(rfq.type)) {
            dispatch({
                type: GET_PORT_DETAILS,
                params: {
                    limit: 10,
                    offset: 0
                }
            });
        }
        // this.setState({
        //     addTrip: true
        // })
    }

    saveAndClose = () => {
        const { dispatch, rfq } = this.props;
        dispatch({
           type: CREATE_RFQ,
           data: rfq.getApiData(),
           rfq: rfq,
           saveAndClose: true
        });
     }

     editTrip = (trip) => {
        this.onClickAddTrip(trip);
     }

     deleteTrip = (trip) => {
        const { dispatch, rfq } = this.props;
        dispatch({
           type: DELETE_TRIP,
           data: {
              tripId: trip.id,
              parentTripId: trip.parentTripId || undefined,
           },
           params: {
              rfqId: rfq.id,
              limit: 1000,
              offset: this.state.offset
           }
        })
     }

     toggleConfirmation = () => {
        this.setState({
          showConfirmation: !this.state.showConfirmation,
       })
     }

     closeTrip = () => {
        const { dispatch } = this.props;
        dispatch({
            type: ADD_TRIP_ADDING,
            addingTrip: false
        }); 
        this.setState({ isTripExists: null });
     }

    render() {
        const { activeView, addTrip, rfqDetailsSubmitted, cargoDetailsSubmitted, biddingDetailsSubmitted } = this.state;
        const { 
            rfq, 
            transporters, 
            groups, 
            contractTenureList, 
            packingTypes, 
            productCategories, 
            businessVolumes, 
            paymentCycles, 
            pricingBasis, 
            systemTime, 
            loader, 
            vehicleTypes, 
            vehicleBodyTypes,
            trips,
            trip,
            tripCount,
            costHeadList,
            currencyTypes,
            currencyDetails,
            addingTrip,
            portsList
        } = this.props;
        let disableSubmitTrips = (rfq && rfq.type === 12 && !trips.length);
        if(rfq && rfq.type === 12 && trips.filter(trip => (!(trip.routeCode.trim() && trip.vehicleTypeName && trip.vehicleBodyType && trip.stops[0].state && trip.stops[trip.stops.length - 1].state) && trip.biddingDetails.diesel_price)).length > 0) {
            disableSubmitTrips = true;
        }
        return (
            <>
                <Sticky>
                    {(loader || !rfq) && <ActionLoader fixed={true}/>}
                    {rfq &&  <div className='pb-40 wt-100p'>
                        <div className='pr tCenter'>
                            <Background  />
                        </div>
                        <RFQStatusBar activeView={activeView}/>
                        {!this.viewMode && <>
                            {activeView === 1 && 
                            <div className='mainRFQ pb-50'>
                                <div ref={(e) => { this.rfqDetailsRef = e; }}>
                                    <RFQInformation 
                                        onChange={this.onChange}
                                        rfqDetails={rfq.rfqDetails}
                                        viewMode={this.viewMode}
                                        rfqType={rfq.type}
                                        rfq={rfq}
                                        contractTenureList={contractTenureList}
                                        rfqDetailsSubmitted={rfqDetailsSubmitted}
                                    />
                                </div>
                                <div ref={(e) => { this.cargoDetailsRef = e; }}>
                                    <CargoInformation 
                                        onChange={this.onChange}
                                        cargoInfo={rfq.cargoInfo}
                                        packingTypes={packingTypes}
                                        productCategories={productCategories}
                                        viewMode={this.viewMode}
                                        submitted={cargoDetailsSubmitted}
                                        rfqType={rfq.type}
                                    />
                                </div>
                                <div ref={(e) => { this.biddingDetailsRef = e; }}>
                                    <BiddingDetails
                                        biddingDetails={rfq.biddingDetails}
                                        onChange={this.onChange}
                                        paymentCycles={paymentCycles}
                                        businessVolumes={businessVolumes}
                                        pricingBasis={pricingBasis} 
                                        systemTime={systemTime}
                                        viewMode={this.viewMode}
                                        viewType="rfq"
                                        rfqServiceType={rfq.rfqDetails.serviceType}
                                        submitted={biddingDetailsSubmitted}
                                        rfqType={rfq.type}
                                        rfq={rfq}
                                        rfqDetails={rfq.rfqDetails}
                                        uploadDocument={this.uploadDocument}
                                        removeDocument={this.removeDocument}
                                        documents={rfq.documents}
                                        bidEndTimeValue={rfq.bidEndTimeValue}
                                    />
                                </div>
                                {
                                    <div ref={(e) => { this.transporterDetailsRef = e; }} className='mb-50 w-inherit'>
                                        <GroupingProviders 
                                            viewMode={this.viewMode}
                                            searchGroupsAndTransporters={this.searchGroupsAndTransporters}
                                            transporters={transporters}
                                            rfq={rfq}
                                            groups={groups || []}
                                            submitted={this.state.transporterDetailsSubmitted}
                                        />
                                    </div>
                                }
                            </div>}
                            {activeView === 2 && 
                                <>
                                    {!addingTrip ? <div className='eximTripTable'>
                                        <TripTableHeader  
                                            onClickAddTrip={this.onClickAddTrip}
                                            downloadTrips={this.downloadTrips}
                                            uploadTrips={this.uploadTrips}
                                            trips={trips || []}
                                            fetchTrips={this.fetchTrips}
                                            vehicleTypes={vehicleTypes}
                                            vehicleBodyTypes={vehicleBodyTypes}
                                            rfqType={rfq.type}
                                        />
                                        <TripTable 
                                            trips={trips || []}
                                            editTrip={this.editTrip}
                                            deleteTrip={this.deleteTrip}
                                            otherCosts={rfq.rfqDetails.otherCosts}
                                            rfqType={rfq.type}
                                        />
                                    </div> :
                                    <div className='mainRFQ'>
                                        <AddTrip 
                                            addTrip={this.addTrip}
                                            rfqType={rfq.type}
                                            rfqServiceType={rfq.rfqDetails.serviceType}
                                            vehicleTypes={vehicleTypes}
                                            vehicleBodyTypes={vehicleBodyTypes}
                                            businessVolumes={businessVolumes}
                                            rfq={rfq}
                                            trip={trip}
                                            costHeadList={costHeadList}
                                            currencyTypes={currencyTypes}
                                            currencyDetails={currencyDetails}
                                            closeTrip={this.closeTrip}
                                            portsList={portsList}
                                        />
                                    </div>}
                                 </>
                            }
                            </>}
                            {(activeView === 3 || this.viewMode) && 
                                <div className={Cx('mb-50', {
                                    'mainRFQ previewRFQ': !addingTrip
                                })}>
                                    {!addingTrip && <>
                                        <RFQInformation 
                                            onChange={this.onChange}
                                            rfqDetails={rfq.rfqDetails}
                                            viewMode={this.viewMode}
                                            rfqType={rfq.type}
                                            rfq={rfq}
                                            contractTenureList={contractTenureList}
                                        />
                                        <CargoInformation 
                                            onChange={this.onChange}
                                            cargoInfo={rfq.cargoInfo}
                                            packingTypes={packingTypes}
                                            productCategories={productCategories}
                                            viewMode={this.viewMode}
                                            submitted={this.state.cargoDetailsSubmitted}
                                            rfqType={rfq.type}
                                        />
                                        <BiddingDetails
                                            biddingDetails={rfq.biddingDetails}
                                            onChange={this.onChange}
                                            paymentCycles={paymentCycles}
                                            businessVolumes={businessVolumes}
                                            pricingBasis={pricingBasis} 
                                            systemTime={systemTime}
                                            viewMode={this.viewMode}
                                            viewType="rfq"
                                            rfqServiceType={rfq.rfqDetails.serviceType}
                                            submitted={this.state.biddingDetailsSubmitted}
                                            rfqType={rfq.type}
                                            rfq={rfq}
                                            rfqDetails={rfq.rfqDetails}
                                            uploadDocument={this.uploadDocument}
                                            removeDocument={this.removeDocument}
                                            documents={rfq.documents}
                                            bidEndTimeValue={rfq.bidEndTimeValue}
                                        />
                                        <div ref={(e) => { this.transporterDetailsRef = e; }} className='mb-20 wt-inherit'>
                                            <GroupingProviders 
                                                viewMode={this.viewMode}
                                                searchGroupsAndTransporters={this.searchGroupsAndTransporters}
                                                transporters={transporters}
                                                rfq={rfq}
                                                groups={groups || []}
                                                submitted={this.state.transporterDetailsSubmitted}
                                            />
                                        </div>
                                    </>}
                                    {!addingTrip ? <div className='cargoInfo mt-10'>
                                        <TripTableHeader  
                                            onClickAddTrip={this.onClickAddTrip}
                                            downloadTrips={this.downloadTrips}
                                            uploadTrips={this.uploadTrips}
                                            trips={trips || []}
                                            fetchTrips={this.fetchTrips}
                                            vehicleTypes={vehicleTypes}
                                            vehicleBodyTypes={vehicleBodyTypes}
                                            rfqType={rfq.type}
                                        />
                                        <TripTable 
                                            trips={trips || []}
                                            editTrip={this.editTrip}
                                            deleteTrip={this.deleteTrip}
                                            otherCosts={rfq.rfqDetails.otherCosts}
                                            rfqType={rfq.type}
                                        />
                                    </div> :
                                    <div className='mainRFQ'>
                                        <AddTrip 
                                            addTrip={this.addTrip}
                                            rfqType={rfq.type}
                                            rfqServiceType={rfq.rfqDetails.serviceType}
                                            vehicleTypes={vehicleTypes}
                                            vehicleBodyTypes={vehicleBodyTypes}
                                            businessVolumes={businessVolumes}
                                            rfq={rfq}
                                            trip={trip}
                                            costHeadList={costHeadList}
                                            currencyTypes={currencyTypes}
                                            currencyDetails={currencyDetails}
                                            closeTrip={this.closeTrip}
                                            portsList={portsList}
                                        />
                                    </div>}
                                </div>}
                    </div>}
                </Sticky>
                {!(addingTrip || this.viewMode) && <BottomSticky  
                    activeView={activeView} 
                    rfq={{}}
                    setNextView={this.setNextView}
                    setPreviousView={this.setPreviousView}
                    discardRfq={this.discardRfq}
                    saveAndClose={this.saveAndClose}
                    disableSubmitTrips={disableSubmitTrips}
                    toggleConfirmation={this.toggleConfirmation}
                />}
                {this.state.showConfirmation && 
                    <ConfirmationPopup
                        text="Are You Sure To Proceed?"
                        onConfirm={this.setNextView}
                        onCancel={this.toggleConfirmation}
                    />}
            </>
        )
    }
}

const mapStateToProps = ({  constants, rfq, common, contracting }) => {
    return {
        rfq: rfq.createdRFQ || null,
        groups: constants.groups || [],
        transporters: constants.transporters || [],
        packingTypes: constants.packingTypes || [],
        vehicleTypes: constants.vehicleTypes || [],
        vehicleBodyTypes: constants.vehicleBodyTypes || [],
        branchesList: constants.branchesList || [],
        contractTenureList: constants.contractTenureList || [],
        productCategories: constants.productCategories || [],
        paymentCycles: constants.paymentCycles || [],
        businessVolumes: constants.businessVolumes || [],
        pricingBasis: constants.pricingBasis || [],
        systemTime: common.systemTime,
        loader: rfq.createRFQ.dataSubmitting || rfq.deleteAddedTrip || rfq.trips.dataSubmitting || rfq.trips.dataLoading || rfq.courierTrips.dataLoading ||  rfq.documents.dataSubmitting || rfq.uploadTemplates.dataSubmitting || contracting.loader,
        selectedNavBranch: constants.selectedNavBranch || {},
        trips: rfq.trips.data,
        trip: rfq.trips.trip,
        tripsCount: rfq.trips.tripsCount,
        costHeadList: constants.costHeadList || [],
        currencyTypes: constants.currencyTypes || [],
        currencyDetails: constants.currencyDetails || [],
        addingTrip: rfq.trips.addingTrip,
        portsList: constants.portsList || []
    }
}

export default connect(mapStateToProps)(EXIMRFQCreate);